<template>
  <div id="app">
	<!-- <NavBar></NavBar> -->
    <router-view></router-view>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'swiper/css/swiper.min.css'
import 'swiper/js/swiper.min.js'


// import NavBar from './components/NavBar/NavBar.vue'

export default {
	name: 'app',
	// components: {
	// 	NavBar
	// }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
